import { combineReducers } from 'redux-immutable'

import login from 'app/pages/login/reducers'

const rootReducer = combineReducers({
  login,
})

export default rootReducer
